<template lang="pug">
.dashboard(:class="class_")
  NetworkStatus
  SystemError(:errors="errors")
  .network-overlay
  Navbar
  Content(:expanded="expanded")
</template>

<script>
import NetworkStatus from "Components/NetworkStatus/Index";
import Navbar from "Dashboard/components/Navbar/Index";
import Content from "Dashboard/components/Content/Index";

import "./scss";
import { Events } from "@timesheets/webapp-support";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { kebabCase } from "@gemma/utils";
// import { NavbarToggledEvent } from "../../app/events";

// WebApplicationConstants.eventBus.createFilters().addSubscription(event => {
//   if (event.data.newBreakpoint === ResponsiveBreakpoints.xs) {
//     WebApplicationConstants.eventBus.publish(new NavbarToggledEvent({ expanded: false }));
//   }
// });

const getExpanded = () => {
  const current = window.Breakpoints.current();
  const expanded = current.min >= window.Breakpoints.get("md").min;
  return expanded;
};

export default {
  name: "Dashboard",
  components: {
    NetworkStatus,
    Content,
    Navbar,
  },
  data() {
    const expanded = getExpanded();
    return {
      errors: [],
      documentTitle: "Your dashboard",
      expanded,
      classes: {
        role: undefined,
        networkStatus: "online",
        expanded: expanded ? "" : "collapsed",
      },
    };
  },
  computed: {
    class_() {
      return Object.keys(this.classes)
        .map(key => this.classes[key])
        .join(" ")
        .trim();
    },
  },
  watch: {
    "currentRole.type"(newValue) {
      this.classes.role = kebabCase(newValue);
    },
  },
  created() {
    this.classes.role = this.currentRole ? kebabCase(this.currentRole.type) : "";
    window.Breakpoints.on("change", this.changed);
    WebApplicationConstants.eventBus.createFilter(Events.NavbarToggledEvent).addSubscription(
      () => {
        this.expanded = !this.expanded;
        this.classes.expanded = this.expanded ? "" : "collapsed";
        const expanded = this.expanded ? Events.SidebarWidthState.Expanded : Events.SidebarWidthState.Collapsed;
        const event = new Events.SidebarWidthChangedEvent(expanded);
        const publish = () => WebApplicationConstants.listenerEventBuses.system.emit(event);
        if (this.expanded) {
          publish();
        } else {
          setTimeout(() => publish(), 500);
        }
      },
      undefined,
      this
    );
    this.$store.commit("header/title", {
      context: this,
      faIcon: this.$icons.newsFeed,
      text: "Welcome!",
    });
  },
  destroyed() {
    window.Breakpoints.off("change", undefined, this.changed);
  },
  mounted() {
    const appMountedEvent = new Events.AppMountedEvent();
    WebApplicationConstants.listenerEventBuses.system.emit(appMountedEvent);

    const sidebarWidthChangedEvent = new Events.SidebarWidthChangedEvent(this.expanded ? Events.SidebarWidthState.Expanded : Events.SidebarWidthState.Collapsed);
    WebApplicationConstants.listenerEventBuses.system.emit(sidebarWidthChangedEvent);
  },
  methods: {
    changed() {
      const expanded = getExpanded();
      this.expanded = expanded;
    },
  },
};
</script>
